export default "__VITE_ASSET__COos2HzA__"